import { render, staticRenderFns } from "./AlertPopup.vue?vue&type=template&id=3fb77b16&scoped=true&"
import script from "./AlertPopup.vue?vue&type=script&lang=js&"
export * from "./AlertPopup.vue?vue&type=script&lang=js&"
import style0 from "./AlertPopup.vue?vue&type=style&index=0&id=3fb77b16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb77b16",
  null
  
)

export default component.exports